import { fetchFromDatoProxy } from "lib/cms/dato";
import type {
  FetchBriefingsParams,
  FetchBriefingsResult,
} from "content-ui/briefings/types";
import axios from "axios";

export const BRIEFINGS_PAGE_SIZE = 16;

export const fetchDatoBriefings = async ({
  preview = false,
  first = BRIEFINGS_PAGE_SIZE,
  skip = 0,
  orderBy,
  filter,
}: FetchBriefingsParams): Promise<FetchBriefingsResult> => {
  const filterValue = filter || [];
  const optionsArray = filterValue.map(
    (filterEl) => `{ sectorName: { matches: { pattern: "${filterEl}" } } }`
  );
  const filterRenderedValue = `{ OR: [${optionsArray.join(",")}] }`;
  const filterCacheKeys = filterValue
    .sort((a, b) => (a < b ? -1 : 1))
    .map((el) => el.toLowerCase())
    .join("_");
  const data = await fetchFromDatoProxy({
    query: `
    query BriefingReportPageQuery {
      allBriefingLists (first: ${first}, skip: ${skip}, orderBy: ${orderBy}, filter: ${filterRenderedValue} ) {
        lastUpdated
        id
        slug
        name
        sectorName
        description
        briefingImage {
          id
          height
          width
          blurUpThumb
          alt
          url
       }
      }
      _allBriefingListsMeta(filter: ${filterRenderedValue}) {
        count
      }
    }
  `,
    preview,
    urlPath: `/briefings/filter/${first}/${skip}/${orderBy}/${filterCacheKeys}`,
  });

  if (!data || data?.allBriefingLists?.length === 0)
    return { list: [], count: 0 };

  const briefings = data.allBriefingLists.map((briefing) => {
    const publishDate = new Date(briefing.lastUpdated);
    const publishTimestamp = publishDate.getTime();

    return {
      id: briefing.id,
      url: `/pro/briefings/${briefing.slug}`,
      title: briefing.name,
      subtitle: briefing.description,
      slug: briefing.slug,
      publishTimestamp,
      isMemberContent: false,
      isRegisteredContent: false,
      isProContent: true,
      isNonFree: true,
      contentSubscriptionLevel: "is_pro",
      SEO: {},
      marketLabel: briefing.sectorName,
      pdf: null,
      dato: true,
      briefingImage: briefing.briefingImage,
    };
  });

  return {
    list: briefings,
    count: data._allBriefingListsMeta.count,
  };
};

export const fetchBriefingsByPage = async (
  params: FetchBriefingsParams,
  url = "/api/briefings"
) => {
  return await axios
    .get<FetchBriefingsResult>(url, { params })
    .then((res) => res.data);
};
